// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;There are many that say, &#145;Who will show us any good?&#146;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;Lord, lift up the light of your countenance upon us.<br> </p> </div></div>";
// Exports
module.exports = code;